

















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ inheritAttrs: false })
export default class FormCheckbox extends Vue {
  @Prop({ required: true })
  value!: boolean;

  @Prop({ required: false, default: "" })
  label!: string;

  @Prop({ required: false, default: true })
  screenReaderLabel!: boolean;

  @Prop({ required: false, default: "" })
  inputClass!: string;

  @Prop({ required: false, default: "" })
  inputAlign!: "center"; // default left

  get disabledClass() {
    return this.$attrs["disabled"] ? "disabled" : "";
  }

  get screenReaderLabelClass() {
    return this.screenReaderLabel ? "screen-reader-text" : "";
  }

  get alignClass() {
    return this.inputAlign ? "checkbox-center" : "";
  }

  updateChecked(event: any) {
    this.$ga.checkbox(this.label, event.target.checked);
    this.$emit("input", event.target.checked);
    this.$emit("updated");
  }
}
